export const StandardDateFormat = 'M/d/yyyy';

export const MillisecondsPerDay = 86400000;

export const FrequencyMonthCountMap = Object.freeze({
  Monthly: 1,
  BIMonthly: 2,
  Quarterly: 3,
  Yearly: 12,
});
